import {
  completeApplicantStep,
  setRequestIdentifier,
  setStepApplicantEdited,
} from "../../../../../../store/redux/slice/Forms/seVerLetterForm";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { createSEApplicantDetailsValidationSchema } from "../../../../../../yup/common/applicant/applicantDetailsValidationSchema";
import { initialSEVerLetterApplicantDetails } from "../../../../../../init/common/applicantDetailsInitialValues";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepApplicant from "../../../../../../hooks/useStepApplicant";
import { ApplicationSubtype } from "@duosoftbg/nacid-components";
import SecondaryEduApplicantDetailsForm from "../../../common/form/applicant/SecondaryEduApplicantDetailsForm";

const SEVerLetterStepApplicant = () => {
  const seVerLetterForm = useAppSelector((state) => {
    return state.Forms.SEVerLetterForm;
  });

  const { methods, onSubmit } = useStepApplicant(
    seVerLetterForm,
    baseEndpointPaths.seRecognition,
    createSEApplicantDetailsValidationSchema,
    setStepApplicantEdited,
    setRequestIdentifier,
    completeApplicantStep,
    initialSEVerLetterApplicantDetails,
    false,
    false,
    true,
  );

  useFormReset(ApplicationSubtype.SE_RECOGNITION, seVerLetterForm.applicantDetails, methods.reset);

  return <SecondaryEduApplicantDetailsForm methods={methods} onSubmit={onSubmit} hasRepresentativeCompany={true} />;
};
export default SEVerLetterStepApplicant;
